export default "/assets/images/live-room-screenshot.1841eeb8691fcbf6.png";